import { types } from '../types'

const initialState = {
  waiting: false,
  success: false,
  error: '',
  profile: {},

  waitingChangePassword: false,
  successChangePassword: false,
  errorChangePassword: false,

  waitingUpdateProfile: false,
  successUpdateProfile: false,
  errorUpdateProfile: false,

  waitingUploadProfilePhoto: false,
  successUploadProfilePhoto: false,
  errorUploadProfilePhoto: false,
  statusUploadProfilePhoto: false,

  waitingGetProfilePhoto: false,
  successGetProfilePhoto: false,
  errorGetProfilePhoto: false,
  urlGetProfilePhoto: ''

}

const profileReducer = (state = initialState, { type, action, error }) => {
  switch (type) {


    case types.GET_PROFILE_REQUEST: {
      return {
        ...state,
        waiting: true,
        success: false,
        displayToast: false

      }
    }
    case types.GET_PROFILE_SUCCESS: {

      return {
        ...state,
        waiting: false,
        profile: action.data,
      }
    }
    case types.GET_PROFILE_ERROR: {

      return {
        ...state,
        waiting: false,
        // error: error?.response?.data?.message,
        // displayToast: action.option.enable_message

      }
    }

    case types.UPDATE_PROFILE_REQUEST: {
      return {
        ...state,
        waitingUpdateProfile: true,
        successUpdateProfile: false,
        errorUpdateProfile: false,
        displayToast: false

      }
    }
    case types.UPDATE_PROFILE_SUCCESS: {
      return {
        ...state,
        waitingUpdateProfile: false,
        successUpdateProfile: true,
        errorUpdateProfile: false,


      }
    }
    case types.UPDATE_PROFILE_ERROR: {
      return {
        ...state,
        waitingUpdateProfile: false,
        successUpdateProfile: false,
        errorUpdateProfile: true,

      }
    }
    case types.CHANGE_PASSWORD_REQUEST: {

      return {
        ...state,
        waitingChangePassword: true,
        successChangePassword: false,
        errorChangePassword: false
      }
    }
    case types.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        waitingChangePassword: false,
        successChangePassword: true,
        errorChangePassword: false

      }
    }
    case types.CHANGE_PASSWORD_ERROR: {

      return {
        ...state,
        waitingChangePassword: false,
        errorChangePassword: error?.data?.title,
        successChangePassword: false
      }
    }

    case types.SET_PASSWORD_REQUEST: {
      return {
        ...state,
        waiting: true,
        success: false,

      }
    }
    case types.SET_PASSWORD_SUCCESS: {

      return {
        ...state,
        waiting: false,
        success: true,

      }
    }
    case types.SET_PASSWORD_ERROR: {

      return {
        ...state,
        waiting: false,
        error: action.error,


      }
    }

    case types.UPLOAD_PROFILE_PHOTO_REQUEST: {
      return {
        ...state,
        waitingUploadProfilePhoto: true,
        successUploadProfilePhoto: false,
        errorUploadProfilePhoto: false,
        statusUploadProfilePhoto: false
      }
    }
    case types.UPLOAD_PROFILE_PHOTO_SUCCESS: {
      return {
        ...state,
        waitingUploadProfilePhoto: false,
        successUploadProfilePhoto: true,
        errorUploadProfilePhoto: false,
        statusUploadProfilePhoto: action.data
      }
    }
    case types.UPLOAD_PROFILE_PHOTO_ERROR: {
      return {
        ...state,
        waitingGetProfilePhoto: false,
        successGetProfilePhoto: false,
        statusGetProfilePhoto: false
      }
    }

    case types.GET_PROFILE_PHOTO_REQUEST: {

      return {
        ...state,
        waitingGetProfilePhoto: true,
        successGetProfilePhoto: false,
        errorGetProfilePhoto: false,
        urlGetProfilePhoto: ''
      }
    }
    case types.GET_PROFILE_PHOTO_SUCCESS: {
      return {
        ...state,
        waitingGetProfilePhoto: false,
        successGetProfilePhoto: true,
        errorGetProfilePhoto: false,
        urlGetProfilePhoto: action.data
      }
    }
    case types.GET_PROFILE_PHOTO_ERROR: {

      return {
        ...state,
        waitingGetProfilePhoto: false,
        successGetProfilePhoto: false,
        errorGetProfilePhoto: action?.data?.title,
        urlGetProfilePhoto: ''
      }
    }




    case types.PROFILE_RESET_PROPS: {
      return {
        ...state,
        waiting: false,
        success: false,
        error: '',


        waitingUpdateProfile: false,
        successUpdateProfile: false,
        errorUpdateProfile: false,

        waitingChangePassword: false,
        successChangePassword: false,
        errorChangePassword: false,

        waitingUploadProfilePhoto: false,
        successUploadProfilePhoto: false,
        errorUploadProfilePhoto: false,
        statusUploadProfilePhoto: false,

        waitingGetProfilePhoto: false,
        successGetProfilePhoto: false,
        errorGetProfilePhoto: false,
        urlGetProfilePhoto: ''
      }
    }
    case types.RESET_PROFILE: {

      return {
        ...state,
        profile: {}
      }
    }
    default:
      return state
  }
}

export default profileReducer;